import { getProfile, login, logout } from '../../services/api';
import { set_route_id } from './route';

export function load_profile() {
    return async dispatch => {
        try {
            const res = await getProfile()
            const role = res.data.user.role
            await dispatch(profile_loaded(res))
            if (role === "SALESMAN") {
                // Set route id to include route detail page in menu
                await dispatch(set_route_id(res.data.user.current_route_id))
            }
            return
        }
        catch(e) {
            console.error(e)
            return
        }
    }
}

export function login_profile(username, password) {
    return async dispatch => {
        try {
            await login(username, password)
            const res = await getProfile()
            const role = res.data.user.role
            await dispatch(profile_loaded(res))
            if (role === "SALESMAN") {
                // Set route id to include route detail page in menu
                await dispatch(set_route_id(res.data.user.current_route_id))
            }
            return role
        }
        catch(e) {
            console.error(e)
            return null
        }
    }
}

export function logout_profile() {
    return async dispatch => {
        try {
            await logout()
            await dispatch(logged_out())
            return
        }
        catch(e) {
            console.error(e)
            return
        }
    }
}

function profile_loaded(profile) {
    return { type: 'PROFILE_LOADED', profile }
}

function logged_out() {
    return { type: 'LOGGED_OUT' }
}
